import axios from 'axios'
import { Message } from 'element-ui';
import { getCache, clearCache} from '@/utils'

class Request {
    constructor() {
        this.config = {
            baseURL: "/",
            timeout: 20000,
            headers: {
                "content-type": "application/json",
            }
        }
        this.instance = axios.create(this.config)

        // 添加请求拦截器
        this.instance.interceptors.request.use(function (config) {
            config.headers['token'] = 'Bearer ' + getCache('xczn_merchant_token')
            // config.headers['x-csrf-token'] = Cookies.get('csrfToken')
            // 在发送请求之前做些什么
            return config;
        }, function (error) {
            // 对请求错误做些什么
            return Promise.reject(error);
        });

        // 添加响应拦截器
        this.instance.interceptors.response.use(function (response) {
            // 对响应数据做点什么
            const { code, msg } = response.data
            
            if (response.config.responseType == "blob") { //判断下载
                return response
            }

            switch (code) {
                case 0:
                    return response
                case 401:
                    clearCache('token')
                    clearCache('nickname')
                    Message({
                        message: msg,
                        type: 'error',
                        duration:2000,
                        onClose: () => {
                            window.location.href ="/"
                        }
                    })
                   
                    return 
                default:
                    Message({ message: msg, type:'error'})
                    return Promise.reject(response)
            }   
            //return response;
        }, function (error) {
            // 对响应错误做点什么
            return Promise.reject(error);
        });
    }
    
    post(url, data, headers = {}) {
        return new Promise((resolve, reject) => {
            this.instance.request({
                method: "post",
                url,
                data,
                headers
            }).then((res) => {
                if (headers?.delay && headers.delay) {
                    setTimeout(() => {
                        resolve(res.data)
                    }, headers.delay);
                } else {
                    resolve(res.data)
                }
            })
            .catch((err) => {
                reject(err)
            })
        })
    }

    get(url, params, headers = {}) {
        return new Promise((resolve, reject) => {
            this.instance.request({
                method: "get",
                url,
                params,
                headers
            }).then((res) => {
                resolve(res.data)
            }).catch((err) => {
                reject(err)
            })
        })
    }


    download(url, data) {
        return new Promise((resolve, reject) => {
            this.instance.request({
                method: "post",
                url,
                data,
                responseType: 'blob'
            }).then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
        })
    }

    uploadPutFile(url, data, callBack,type) {
        let contentType = 'application/json'
        if(type){
            contentType = type
        }
        return new Promise((resolve, reject) => {
            const instance = axios.create({ timeout: 600000})
            instance.request({
                method: "put",
                url,
                data,
                headers: { 'Content-Type': contentType },
                onUploadProgress: (progressEvent) => {
                    let loaded = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                    callBack(loaded)
                }
            }).then((res) => {
                resolve(res.data)
            }).catch((err) => {
                reject(err)
            })
        })
    }

}

export default new Request()


// WEBPACK FOOTER //
// ./src/api/base.js